import globals from "imports/globals";
import $ from "cash-dom";
import { gsapTrigger as WyPt, getOffset } from "Utilities";

const component = (function () {
    /**
     * Initialize Hero instances
     */
    window.addEventListener("load", function () {
        if ($(".enter").length) {
            if (globals.debug) console.log("component-enter initialized");
            var offsetViewport =
                globals.screenOrientation == "portrait"
                    ? window.innerHeight
                    : window.innerHeight * globals.visibilityThreshold.landscape;
            $(".enter").each(function () {
                var element = $(this)[0];
                var offsetElement = getOffset(element);

                setTimeout(function () {
                    var instance = new WyPt({
                        element: element,
                        offset: {
                            top: offsetElement - offsetViewport,
                            bottom: offsetElement - offsetViewport,
                        },
                        callback: {
                            enter: function (_el) {
                                $(_el).addClass("in-view");
                                instance.trigger.kill();
                            },
                            leave: function (_el) {
                                $(_el).removeClass("in-view");
                            },
                        },
                        pointMode: true,
                    });
                }, 1000);
            });

            $(window).on("resizeEnd", function () {
                offsetViewport =
                    globals.screenOrientation == "portrait"
                        ? window.innerHeight
                        : window.innerHeight * globals.visibilityThreshold.landscape;
            });
        }
    });
})();

export default component;
